isAccountCancelConfirmPage